export const mockupsCompareStats = ({dispatch}) => next => (action) => {
    next(action);
}; 